/** The centred page column every routed page sits in, with responsive side gutters. */
export const PAGE_SHELL = 'mx-auto w-full max-w-[1280px] px-4 pt-[38px] pb-12 sm:px-6 lg:px-10';
